// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2IPBd","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2K-6j"};